import React from 'react'
import "../../styles/ApprovalConfiguration.css"
import MailHeader from './MailHeader'
import { useState, useEffect } from 'react'
import ReactPaginate from "react-paginate";
import { useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from "react-toastify"
import axiosInstance from '../../axiosInstance'
import CommonFooter from '../../CommonFooter/CommonFooter';


const MailConfiguration = () => {

    const [tableData, setTableData] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [limit, setLimit] = useState(5);
    const [currentPage, setCurrentPage] = useState(0);
    const [sortBy, setSortBy] = useState("dateCreated");
    const [skip, setSkip] = useState(0);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        fetchMailConfigurations(searchTerm);
    }, [limit, skip]);

    const fetchMailConfigurations = async (term = '') => {
        setLoading(true);
        setError(null);
        try {
            const response = await axiosInstance.post(
                `/mailqueue/list`,
                {
                    limit,
                    skip,
                    sortBy,
                    search: term || ''
                },
            );

            console.log("Mail Response", response.data);

            if (response.data && response.data.success) {
                setTableData(response.data.mail_queue || []);
                setTotalCount(response.data.totalCount || 0);
                setTotalPages(Math.ceil(response.data.totalCount / limit));
            } else {
                throw new Error(response.data.message || 'Failed to fetch data');
            }
        } catch (err) {
            setError(err.message || 'Failed to fetch Mail Queues');
            console.error('Error fetching Mail Queues:', err);
        } finally {
            setLoading(false);
        }
    };


    const handlePageClick = ({ selected }) => {
        const newSkip = selected * limit;
        setCurrentPage(selected);
        setSkip(newSkip);
        setSelectedRows([]);
    };

    const handleDateSelection = (date) => {
        console.log("Selected Date:", date);
    };

    const isAllSelected = selectedRows.length === tableData.length && tableData.length > 0;
    const isAnySelected = selectedRows.length > 0;

    const handleCheckboxChange = (e, id) => {
        if (e.target.checked) {
            setSelectedRows([...selectedRows, id]);
        } else {
            setSelectedRows(selectedRows.filter(rowId => rowId !== id));
        }
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            setSelectedRows(tableData.map(row => row.id));
        } else {
            setSelectedRows([]);
        }
    };

    const handleLimitChange = (e) => {
        const newLimit = Number(e.target.value);
        setLimit(newLimit);
        setCurrentPage(0);
        setSkip(0);
    };

    const handleSearch = async (term) => {
        setSearchTerm(term);
        setSkip(0);
        await fetchMailConfigurations(term);
    };


    return (
        <>
            <MailHeader onSearch={handleSearch} />
            <div className='approval-config'>
                <div className='approval-header'>
                    <div className='approval-left-header'>
                        <p>All Mail Queues ({totalCount})</p>
                    </div>
                    <div className='approval-right-header'>
                        {/* {!isAnySelected ? (
              <>
                <DatePicker onDateChange={handleDateSelection} />

                <h4>Sort by :</h4>
                <div className="dropdown">
                  <select id="options" className="dropdown-select">
                    <option value="option1">Date Created</option>
                    <option value="option2">Project Name</option>
                    <option value="option3">Module</option>
                  </select>
                </div>
              </>
            ) : (
              <button id="deleteBtn" className="deleteBtn" onClick={handleDeleteSelected}>
                Delete Selected
              </button>
            )} */}

                    </div>
                </div>


                <div className="approval-config-table">
                    <table>
                        <thead>
                            <tr>
                                {/* <th style={{ width: "1px" }}>
                                    <input
                                        type="checkbox"
                                        checked={isAllSelected}
                                        onChange={handleSelectAll}
                                    />
                                </th> */}
                                <th style={{ width: "50px", minWidth: "50px", textAlign: "center", padding: "4px" }}>S.No</th>
                                <th>Sender</th>
                                <th>Receipent</th>
                                <th>Subject</th>
                                <th>Trigger Status</th>
                                <th>Created Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableData.length > 0 ? (
                                tableData.map((item, index) => {
                                    return (
                                        <tr key={item.id}>
                                            {/* <td style={{ width: "1px" }}>
                                                <input
                                                    type="checkbox"
                                                    checked={selectedRows.includes(item.id)}
                                                    onChange={(e) => handleCheckboxChange(e, item.id)}
                                                />
                                            </td> */}
                                            <td  style={{ width: "50px", minWidth: "50px", textAlign: "center",padding:'10px' }}>{index + 1}</td>
                                            <td>{item.sender}</td>
                                            <td>{item.receipent}</td>
                                            <td>{item.subject}</td>
                                            <td>{item.status}</td>
                                            <td>{new Date(item.created_at).toLocaleDateString('en-GB').replace(/\//g, '-')}</td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    {searchTerm && tableData.length === 0 && (
                                        <td colSpan="7" style={{ textAlign: 'center', padding: '20px', fontSize: '14px', color: '#666' }}>
                                            No Mailqueue found matching "{searchTerm}"
                                        </td>
                                    )}
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {totalCount > 0 && (
                    <div className="pagination-container d-flex align-items-center justify-content-between mt-3">
                        <div className="Limit-Dropdown">
                            <label htmlFor="limit" className="fw-semibold" style={{ padding: "0" }}>Items per page:</label>
                            <select
                                id="limit"
                                value={limit}
                                onChange={handleLimitChange}
                                className="form-select d-inline w-auto"
                            >
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="15">15</option>
                                <option value="20">20</option>
                            </select>
                        </div>
                        <div className="d-flex align-items-center gap-4">
                            <ReactPaginate
                                previousLabel="Previous"
                                nextLabel="Next"
                                pageCount={totalPages}
                                onPageChange={handlePageClick}
                                forcePage={currentPage}
                                containerClassName="pagination"
                                pageClassName="page-item"
                                pageLinkClassName="page-link"
                                previousClassName="page-item"
                                previousLinkClassName="page-link"
                                nextClassName="page-item"
                                nextLinkClassName="page-link"
                                activeClassName="active"
                                breakLabel="..."
                                breakClassName="page-item"
                                breakLinkClassName="page-link"
                                marginPagesDisplayed={1}
                                pageRangeDisplayed={3}
                                disabledClassName="disabled"
                            />
                        </div>
                    </div>
                )}
            </div>
            <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
            <CommonFooter />
        </>
    )
}

export default MailConfiguration